import { BaseEmptyPrefixControlBehaviour } from './BaseControlBehaviour';
/**
 * Sortable - использует $.ui.sortable
 * основной аттрибут - sortable
 * используется опция revert - плавный анимированный возврат на свою позицию
 */
export class SortableBehaviour extends BaseEmptyPrefixControlBehaviour {
    constructor() {
        super('sortable');
    }

    protected installBehaviour(element: HTMLElement): void {
        $(element).sortable({
            revert: true,
        });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.SortableBehaviour = SortableBehaviour;
